/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { SHOW_LOADER, HIDE_LOADER } from "./types";

const initialState = {
  displayLoader: true,
  component: '',
};

export const loaderReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SHOW_LOADER:
      return {
        ...state,
        displayLoader: true,
        component: action.component,
      };
    case HIDE_LOADER:
      return {
        ...state,
        displayLoader: false,
        component: action.component,
      };
    default:
      return state;
  }
};
